const ActionType = {
  ADD_SOME_ACTION: 'ADD_SOME_ACTION',
  ADD_TO_CHART: 'ADD_TO_CHART',
  SHOW_ADD_TO_CHART: 'SHOW_ADD_TO_CHART',
  UPDATE_ADD_TO_CHART: 'UPDATE_ADD_TO_CHART',
  CHANGE_SHOW_PRODUCT: 'CHANGE_SHOW_PRODUCT',
  CHANGE_PAGE: 'CHANGE_PAGE',
}
export default ActionType
